import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import LinkWithStatus from '../../../../../common/LinkWithStatus'
import { ConnectorPinsContext } from '../../context/context'
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { NavContext } from '../../../../../../context/global_context'

const SearchConnectorsButton = (props) => {
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const [navState, navDispatch] = useContext(NavContext)
  let { vehicle, connector_id } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const connectorsUrl = () => {
    navigate(
      `/vehicles/${vehicle}/dtcs/mappings/${connector_id}/?${createSearchParams(
        {
          dtc_id: searchParams.getAll('dtc_id'),
          connector_name: searchParams.get('connector_name'),
          q: searchParams.getAll('q'),
          dtc_mapping_type: state?.dtc_mapping_type,
          query_type: state?.query_type,
          selected_pins: state?.selected_pins,
          search_old_levels: false,
        }
      )}`
    )
  }

  useState(() => {
    if (navState?.destination_only && state?.selected_pins?.length > 0) {
      setTimeout(() => {
        connectorsUrl()
      }, 200)
    }
  }, [state?.selected_pins, navState?.destination_only])

  const text =
    state?.dtc_mapping_type === 'end'
      ? 'Filter Start Connectors'
      : 'Filter End Connectors'

  return (
    <LinkWithStatus
      className={`btn capitalize my-4 w-full ${navState?.destination_only ? 'disabled' : ' cursor-pointer'}`}
      onClickFunc={() => {
        connectorsUrl()
      }}
    >
      {text}
    </LinkWithStatus>
  )
}

SearchConnectorsButton.propTypes = {}

export default SearchConnectorsButton
